// Grain direction on sheet stock (since 2026-10-25). Mirror of jobq-api sheet_grain.py.
//
// The grain runs along the X axis of the material and Amada lists a sheet X first. JobQ names a
// sheet width x length ("48x120"), so JobQ LENGTH = Amada X = WITH the grain, and WIDTH = Amada Y =
// ACROSS the grain: a JobQ 48 x 120 is Amada's 120 x 48. A remnant keeps the grain of the sheet it
// was cut from, so it must fit that sheet the same way round.

export const GRAIN_TOL_IN = 0.75; // measuring allowance (a 60.5" piece off a 60" sheet is real)

function num(v) {
  const f = parseFloat(v);
  return Number.isFinite(f) && f > 0 ? f : null;
}

// 60 -> "60", 21.2369 -> "21.2369" (Python's :g for these sizes)
export function fmtIn(v) {
  return String(parseFloat(Number(v).toPrecision(6)));
}

// null when width x length fits its parent the same way round (or a size is unknown); else
// { code: 'looks_swapped' | 'bigger_than_sheet', message, suggestedWidth, suggestedLength }.
export function grainCheck(width, length, srcWidth, srcLength, tol = GRAIN_TOL_IN) {
  const w = num(width), l = num(length), sw = num(srcWidth), sl = num(srcLength);
  if (w == null || l == null || sw == null || sl == null) return null;
  if (w <= sw + tol && l <= sl + tol) return null;
  if (l <= sw + tol && w <= sl + tol) {
    return {
      code: 'looks_swapped',
      message: `A ${fmtIn(w)} x ${fmtIn(l)} remnant doesn't fit its ${fmtIn(sw)} x ${fmtIn(sl)} sheet with the grain `
        + `where it was: the sheet's grain runs along its ${fmtIn(sl)}" side, so a piece of it is at most `
        + `${fmtIn(sl)}" with the grain. It fits as ${fmtIn(l)} x ${fmtIn(w)} (with the grain ${fmtIn(w)}").`,
      suggestedWidth: l,
      suggestedLength: w,
    };
  }
  return {
    code: 'bigger_than_sheet',
    message: `A ${fmtIn(w)} x ${fmtIn(l)} remnant is bigger than its ${fmtIn(sw)} x ${fmtIn(sl)} sheet either way round. `
      + 'Check the sizes and the sheet it came from.',
    suggestedWidth: null,
    suggestedLength: null,
  };
}

// "120 x 48" for a JobQ 48 x 120 (Amada order, X first). '' when a size is missing.
export function amadaSizeText(width, length) {
  const w = num(width), l = num(length);
  if (w == null || l == null) return '';
  return `${fmtIn(l)} x ${fmtIn(w)}`;
}

// 'Grain along 120"' for a JobQ 48 x 120. '' when a size is missing.
export function grainText(width, length) {
  const w = num(width), l = num(length);
  if (w == null || l == null) return '';
  return `Grain along ${fmtIn(l)}"`;
}

// The field labels every remnant / sheet size form uses.
export const WIDTH_LABEL = 'Width (in): across the grain, Amada Y';
export const LENGTH_LABEL = 'Length (in): with the grain, Amada X';
